import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from "./locales/en.json";
import arTranslations from "./locales/ar.json";

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ar: {
        translation: arTranslations,
      },
    },
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "en", // Default language
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  });

const applyDocumentLangDir = () => {
  const currentLang = i18n.language || "en";
  document.documentElement.lang = currentLang;
  document.documentElement.dir = currentLang.startsWith("ar") ? "rtl" : "ltr";
};

applyDocumentLangDir();
i18n.on("languageChanged", applyDocumentLangDir);

export default i18n;
